'use client'

import clsx from 'clsx'
import React, { useMemo } from 'react'
import { SwiperSlide } from 'swiper/react'

import ZSwiper from '@/_components/universal/swiper/z-swiper'

import AServiceCard, { IServiceCardProps, SERVICE_CARD_THEME } from './components/a-service-card'

interface IZSectionServicesProps {
	title: string
	subtitle: string
	description: string
	services: IServiceCardProps[]
	buttonText: string
	background?: boolean
	className?: string
	textClassName?: string
}

const ZSectionServices: React.FC<IZSectionServicesProps> = ({
	title,
	subtitle,
	description,
	services,
	buttonText,
	background,
	className,
	textClassName
}) => {
	const formattedDescription = useMemo(
		() => description.replace(/\*\*(.*?)\*\*/g, '<b style="font-weight: 500;">$1</b>'),
		[description]
	)

	return (
		<section
			id='sluzby'
			className={clsx(className, `${background ? 'bg2' : ''} pdt-60 pdb-60 pos_rel`)}
		>
			<div className='wrapper'>
				<div className='section_head'>
					<h2 className='title_side text_uc'>{title}</h2>
					<h3 className='title_h1'>{subtitle}</h3>
					<div className={clsx('page_content reset_margins nobalance', textClassName)}>
						<p
							className='max-w-[375px]'
							dangerouslySetInnerHTML={{
								__html: formattedDescription
							}}
						/>
					</div>
				</div>
			</div>

			<div className='max-w-7xl mx-auto mt-12 mb-4 px-0 sm:px-6 xl:px-8'>
				<div className='hidden xl:grid xl:grid-cols-3 xl:gap-6'>
					{services.map(service => (
						<AServiceCard key={service.title} {...service} buttonText={buttonText} />
					))}
				</div>

				<div className='block xl:hidden'>
					<ZSwiper
						spaceBetween={0}
						initialSlidesPerView={1.1}
						showCounter
						showProgressbar
						showArrows
						breakpoints={{
							640: { slidesPerView: 2 },
							1026: { slidesPerView: 3 }
						}}
					>
						{services.map(service => (
							<SwiperSlide key={service.title}>
								<AServiceCard {...service} buttonText={buttonText} />
							</SwiperSlide>
						))}
					</ZSwiper>
				</div>
			</div>
		</section>
	)
}

export default ZSectionServices
export { AServiceCard, SERVICE_CARD_THEME }
export type { IServiceCardProps }
